module.exports = __webpack_public_path__ + "static/media/weather.29ab9e4e.png";